import type { ReactNode } from 'react'
import { Button } from '../widgets/Button'

/**
 * SEN-703 — the friendly filtered-to-empty state ("No X match that filter" +
 * Clear filter CTA) instead of a blank chart/table. ONE component, mounted at
 * exactly two seams: ViewHost._ViewHostQuery (every frame renderer) and
 * CollectionTable (identity path). `children` lets the frame seam keep the
 * FrameAnnotations (empty frames still carry their WHY — annotate-not-block).
 */
export function FilteredEmptyState({
  pluralName,
  onClear,
  children,
}: {
  pluralName: string
  onClear: () => void
  children?: ReactNode
}) {
  return (
    <div data-testid="filtered-empty" className="flex flex-col items-center gap-2 p-8 text-sm text-muted-foreground">
      {children}
      <div>No {pluralName || 'records'} match that filter</div>
      <Button variant="outline"
        data-testid="filtered-empty-clear"
        onClick={onClear}
        className="font-medium"
      >
        Clear filter
      </Button>
    </div>
  )
}
